import { render, staticRenderFns } from "./Dash.vue?vue&type=template&id=b40e5562&scoped=true"
import script from "./Dash.vue?vue&type=script&lang=ts"
export * from "./Dash.vue?vue&type=script&lang=ts"
import style0 from "./Dash.vue?vue&type=style&index=0&id=b40e5562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40e5562",
  null
  
)

export default component.exports